import { BaseDto } from './base.dto';

export class CustomerFavoriteDto extends BaseDto {
  customerId: number;
  groupName: string;
}
